module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.3d3a53586bd78d1069ae.svg";


//////////////////
// WEBPACK FOOTER
// E:/R1/Angular/turnero/web-visor-cliente/~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module chunks = 2